//import api from '@/services/api';
import {api} from "../main";
export default{

updateCalificacionEntregable(entregable_id, formData){
        return api({
            url:  `/api/entregables/updateCalificacion/${entregable_id}`,
            method: 'POST',
            headers: {
                'content-type': 'multipart/form-data'
            },
            data: formData
        });
    },

    getCursoEntregables(grupo_id){
        return api({
            url: `/api/entregables/cursoEntregables/${grupo_id}`,
            method: 'GET',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    getCursos(){
         return api({
             url: `/api/cursos`,
             method: 'GET',
             headers: {
                 'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
             }
         });
    },

    getCursosConEntregablesPorGrupo(grupo_id){
        return api({
            url: `/api/cursos/conEntregablesPorGrupo/${grupo_id}`,
            method: 'GET',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    getCursosConEntregables(){
        return api({
            url: `/api/cursos/conEntregables`,
            method: 'GET',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    delete(id){
        let url = `/api/cursos/destroy/${id}`;
        return api({
            url: url,
            method: 'DELETE',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    revalidarCursos(formData){
        let url          = `/api/cursos/revalidarCursos`;
        return api({
            url: url,
            method: 'POST',
            headers: {
                'content-type': 'multipart/form-data'
            },
            data: formData
        });
    },

    save(formData){
        let url          = `/api/cursos/store`;
        return api({
            url: url,
            method: 'POST',
            headers: {
                'content-type': 'multipart/form-data'
            },
            data: formData
        });
    },

    update(curso_id, formData){
        return api({
            url:  `/api/cursos/update/${curso_id}`,
            method: 'POST',
            headers: {
                'content-type': 'multipart/form-data'
            },
            data: formData
        });
    },

}